import { useState } from 'react';

import { isIpOrBlock, isRange } from './ipFilter';

export type IpMode = 'single' | 'range';

/** What the popover's form holds until Apply: one address or block, or a range. */
export function useSourceIpDraft() {
  const [mode, setMode] = useState<IpMode>('single');
  const [single, setSingle] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const valid = mode === 'single' ? isIpOrBlock(single.trim()) : isRange(from.trim(), to.trim());

  /** Fills the form from the applied filter value. */
  function load(value: string) {
    const [low, high] = value.split('-');
    if (high !== undefined) {
      setMode('range');
      setFrom(low ?? '');
      setTo(high);
    } else {
      setMode('single');
      setSingle(value);
    }
  }

  /** The filter value the form describes, in the API's `source_ip` shape. */
  function result(): string {
    return mode === 'single' ? single.trim() : `${from.trim()}-${to.trim()}`;
  }

  return { mode, setMode, single, setSingle, from, setFrom, to, setTo, valid, load, result };
}

export type SourceIpDraft = ReturnType<typeof useSourceIpDraft>;
